module.exports = __webpack_public_path__ + "img/Arrow_disabled.313a8b06.svg";